import type PlainDate from '@Domain/PlainDate';

/**
 * Generic over `T` rather than `ConsentFormData` itself, so the FormData never has to import its own
 * constraint back (`guides/forms.md` §1.1).
 */
function isConductedOnProvided<T>(value: PlainDate | null, _formData: T): boolean {
	return value !== null;
}

export default isConductedOnProvided;
